var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThreeDotsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 18,
    viewBox: "0 0 4 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 14C0.89543 14 -1.35705e-07 14.8954 -8.74228e-08 16C-3.91405e-08 17.1046 0.895431 18 2 18C3.10457 18 4 17.1046 4 16C4 14.8954 3.10457 14 2 14Z",
    fill: "#231F20",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 7C0.89543 7 -4.41685e-07 7.89543 -3.93402e-07 9C-3.4512e-07 10.1046 0.89543 11 2 11C3.10457 11 4 10.1046 4 9C4 7.89543 3.10457 7 2 7Z",
    fill: "#231F20",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 -8.74228e-08C0.89543 -3.91405e-08 -7.47664e-07 0.895432 -6.99382e-07 2C-6.511e-07 3.10457 0.89543 4 2 4C3.10457 4 4 3.10457 4 2C4 0.895431 3.10457 -1.35705e-07 2 -8.74228e-08Z",
    fill: "#231F20",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDotsIcon);
export default __webpack_public_path__ + "static/media/three-dots-icon.329d6de7966ce7725493951db2cde016.svg";
export { ForwardRef as ReactComponent };